import moment from 'moment';
import { ICONS } from 'components/Icons';

export const loggedStatusMap = {
  '24h': {
    message: 'You logged an article within the last 24 hours',
    color: 'av-green',
  },
  '3d': {
    message: 'You haven’t logged an article in over 24 hours',
    color: 'av-camel',
  },
  notLogged: {
    message: 'You haven’t logged an article in over 3 days',
    color: 'av-red',
  },
};

export const statusMap = {
  online: {
    color: 'av-green',
    message: 'All systems go',
    icon: ICONS.ONLINE,
  },
  offline: {
    color: 'av-red',
    message: 'Some issues to fix',
    icon: ICONS.OFFLINE,
  },
  warning: {
    color: 'av-camel',
    message: 'Not up and running',
    icon: ICONS.WARNING,
  },
};

export default function getUserStatusDetail(user, currentUser) {
  const isOwner = user && user._id === currentUser._id;
  const { firstName, lastName } = user.profile || {};
  const userName = isOwner ? '' : `${firstName || ''} ${lastName || ''}`.trim();

  const profile = user.profile || {};
  const lastLoggedTime = (user.extensionStats || {})
    .lastLoggedArticleOnExtension;
  const extensions = user.siteInfo?.extensions ?? [];
  const latestExtensions = extensions.sort((ext2, ext1) => {
    return moment(ext2.time).isAfter(ext1.time) ? -1 : 1;
  });
  const isInstalled = latestExtensions.find(
    (ext) => ext && ext.installed && ext.installed.time,
  );
  const isLoggedIn = latestExtensions.filter(
    (ext) =>
      ext &&
      ext.login &&
      ext.login.time &&
      (!ext.login.loggedOutTime ||
        moment(ext.login.loggedOutTime).isBefore(ext.login.time)),
  );
  const isPinnedIn = latestExtensions.filter(
    (ext) =>
      ext &&
      ext.pinned &&
      ext.pinned.time &&
      (!ext.pinned.unpinnedTime ||
        moment(ext.pinned.unpinnedTime).isBefore(ext.pinned.time)),
  );
  const sourceSettingsAnalyzeAll = profile.sourceSettingsAnalyzeAll;
  const sourceSettingsViewWithPoints = profile.sourceSettingsViewWithPoints;
  const sourceSettingsReadingWidget = profile.sourceSettingsReadingWidget;
  const vocabularyEnabled = profile.vocabularyEnabled;
  const settings = [
    sourceSettingsAnalyzeAll,
    sourceSettingsViewWithPoints,
    sourceSettingsReadingWidget,
  ];
  let loggedStatus;

  if (
    lastLoggedTime &&
    moment(lastLoggedTime).isAfter(moment().subtract(1, 'day'))
  ) {
    loggedStatus = '24h';
  } else if (
    lastLoggedTime &&
    moment(lastLoggedTime).isAfter(moment().subtract(3, 'day'))
  ) {
    loggedStatus = '3d';
  } else {
    loggedStatus = 'notLogged';
  }

  let allSettingsStatus;

  if (settings.every((setting) => setting)) {
    allSettingsStatus = 'enabled';
  } else {
    allSettingsStatus = 'disabled';
  }

  const checkedInToday =
    latestExtensions[0] && latestExtensions[0].time
      ? moment(latestExtensions[0].time).isAfter(moment().subtract(1, 'day'))
      : false;

  let userStatus;

  if (
    !isLoggedIn.length ||
    !isPinnedIn.length ||
    !checkedInToday ||
    loggedStatus === 'notLogged'
  ) {
    userStatus = 'offline';
  } else if (allSettingsStatus === 'disabled' || loggedStatus === '3d') {
    userStatus = 'warning';
  } else {
    userStatus = 'online';
  }

  return {
    userStatus,
    isLoggedIn,
    isPinnedIn,
    latestExtensions,
    loggedStatus,
    checkedInToday,
    isOwner,
    userName,
  };
}
